<template>
  <mu-card id="similarPosts" v-if="!isLoading">
    <mu-card-header
      titleClass="readNext"
      :title="$t('message.lifeCategoryListsHeaderText')"
      >
    </mu-card-header>
    <mu-card-text>
      <div class="sidePost" v-for="post, index in posts" :key="`sidepost-${index}`">
        <life-post-info
          :slug="post.post_slug"
          :image="post.post_image"
          :title="post.post_title"
          :time="post.post_date"
          :favourites="post.post_favourites"
        />
      </div>
    </mu-card-text>
  </mu-card>
</template>
<script>
  import LifeApi from '../../../api/LifeStyle';
  import LifePostInfo from "../LifePostInfo/LifePostInfo";

  export default {
    components: {
      LifePostInfo
    },
    props: {
      post_id: {
        type: Number,
        required: true
      },
      size: {
        type: String,
        default: 'medium',
        required: false
      }
    },
    name: 'life-similar-posts',
    data() {
      return {
        isLoading: true,
        posts: []
      }
    },
    methods: {
      loadSimilarPosts() {
        let self = this;
        LifeApi.getSimilarPosts(self.post_id, self.size).then(response => {
          self.posts = response.data;
          self.isLoading = false;
        });
      },
      moment(date) {
        return moment(date);
      },
      goToArticle(slug) {
        let self = this;
        self.$router.push({
          name: 'LifeStyleArticle',
          params: {
            permalink: slug
          }
        });
      },
      initMounted() {
        let self = this;
        self.isLoading = true;
        self.loadSimilarPosts();
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }
</script>
<style lang="less">
  @import '../../../styles/theme.less';
  .sidePost {
    margin: 0 0 24px;
  }
</style>



// WEBPACK FOOTER //
// LifeSimilarPosts.vue?2324b6cf